"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SFInput = function SFInput() {
  return null;
};
var _default = exports["default"] = SFInput; // import React from "react";
// import PropTypes from "prop-types";
// import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
// const typeToClass = {
//   select: "select",
//   textarea: "textarea"
// };
// const SFInput = ({
//   id,
//   name,
//   type,
//   value,
//   onChange,
//   placeholder,
//   label,
//   errors,
//   required,
//   children
// }) => (
//   <div>
//     <FormGroup
//       controlId={id}
//       validationState={errors && errors[id] ? 'error' : undefined}
//     >
//       <ControlLabel>
//         <span className="form-label text-left margin-bottom-xxs">
//           {label}
//         </span>
//       </ControlLabel>
//       <FormControl
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         name={name}
//         type={type}
//         componentClass={type && typeToClass[type]}
//         required={required}
//       >
//         {children}
//       </FormControl>
//     </FormGroup>
//     {errors &&
//       errors[id] &&
//       errors[id].map(e => (
//         <p key={e} style={{ color: 'red' }}>
//           {e}
//         </p>
//       ))}
//   </div>
// );
// SFInput.propTypes = {
//   id: PropTypes.string.isRequired,
//   name: PropTypes.string,
//   type: PropTypes.string,
//   value: PropTypes.string,
//   placeholder: PropTypes.string,
//   label: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
//   errors: PropTypes.object,
//   required: PropTypes.bool,
//   children: PropTypes.array
// };
// export default SFInput;